<template>
  <v-navigation-drawer
    app
    right
    clipped
    width="290"
    v-model="model"
  >
    <perfect-scrollbar style="height: 100%">
      <div class="mt-4 mx-2" >
        <machine-selection />
        <type-selection />
        <status-selection />
        <group-selection />
      </div>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import MachineSelection from './filters/MachineSelection.vue';
import StatusSelection from './filters/StatusSelection.vue';
import TypeSelection from './filters/TypeSelection.vue';
import GroupSelection from './filters/GroupSelection.vue';

export default {
  name: 'PlanningDrawer',
  components: {
    MachineSelection,
    StatusSelection,
    TypeSelection,
    GroupSelection,
  },
  computed: {
    ...mapState('maintenancePlanning', ['drawer']),
    model: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapMutations('maintenancePlanning', ['setDrawer']),
  },
};
</script>
